import {ReactComponent as LogoCoinbase} from '#/components/icons/ico-coinbase.svg';
import {ReactComponent as LogoWalletConnect} from '#/components/icons/ico-wallet-connect.svg';
import {ReactComponent as IconWeb3Auth} from '#/components/icons/ico-web3auth.svg';
import {ReactComponent as LogoMetamask} from '#/components/icons/logo-metamask.svg';
import {FunctionComponent} from 'react';

export const Web3AuthAdapterIcon: FunctionComponent<{
  adapterName: string | null | undefined;
}> = ({adapterName}) => {
  switch (adapterName) {
    case 'openlogin':
      return <IconWeb3Auth className={'w-5 h-5'} />;
    case 'metamask':
      return <LogoMetamask className={'w-6 h-6'} />;
    case 'wallet-connect-v1':
    case 'wallet-connect-v2':
      return <LogoWalletConnect className={'w-5 h-5'} />;
    case 'coinbase':
      return <LogoCoinbase className={'w-6 h-6'} />;
    default:
      return null;
  }
};
